module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_3009.90ffa85f.png";